import { useState } from 'react';
import { Button, C } from './partner-program/shared';
import PartnerApplicationsPanel from './partner-program/PartnerApplicationsPanel';
import PartnersPanel from './partner-program/PartnersPanel';
import ReferralsPanel from './partner-program/ReferralsPanel';
import CommissionsPanel from './partner-program/CommissionsPanel';
import PayoutsPanel from './partner-program/PayoutsPanel';

const TAB_IDS = ['applications', 'partners', 'referrals', 'commissions', 'payouts'] as const;
type TabId = (typeof TAB_IDS)[number];

function titleCase(value: string): string {
  return value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export default function PartnerProgramPanel() {
  const [activeTab, setActiveTab] = useState<TabId>('applications');

  return (
    <section style={{ marginBottom: 32 }}>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
          Partner program
        </div>
        <div style={{ fontSize: 13, color: C.muted, lineHeight: 1.6 }}>
          Founder-operated partner applications, attribution, commission approvals, and manual payout tracking.
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        {TAB_IDS.map((tabId) => (
          <Button
            key={tabId}
            variant={activeTab === tabId ? 'primary' : 'default'}
            onClick={() => setActiveTab(tabId)}
          >
            {titleCase(tabId)}
          </Button>
        ))}
      </div>

      {activeTab === 'applications' && <PartnerApplicationsPanel />}
      {activeTab === 'partners' && <PartnersPanel />}
      {activeTab === 'referrals' && <ReferralsPanel />}
      {activeTab === 'commissions' && <CommissionsPanel />}
      {activeTab === 'payouts' && <PayoutsPanel />}
    </section>
  );
}
